jQuery(document).ready(function($){



  // var assets = {};
  // assets['Size'] = '//www.bedchoices.co.uk/cdn/shop/t/39/assets/icon-size_1024x1024.png?v=31543344121325044601788964240';
  // assets['Headboard Height'] = '//www.bedchoices.co.uk/cdn/shop/t/39/assets/icon-headboard-height_1024x1024.png?v=71651354222714580451788964240';
  // assets['Fabric'] = '//www.bedchoices.co.uk/cdn/shop/t/39/assets/icon-fabric_1024x1024.png?v=32846084406414885621788964240';
  // assets['Ottoman Gas Lift Storage'] = '//www.bedchoices.co.uk/cdn/shop/t/39/assets/icon-ottoman-storage_1024x1024.png?v=90453762790681684271788964240';
  // assets['Storage Option'] = '//www.bedchoices.co.uk/cdn/shop/t/39/assets/icon-ottoman-storage_1024x1024.png?v=90453762790681684271788964240';
  // assets['Ottoman Storage'] = '//www.bedchoices.co.uk/cdn/shop/t/39/assets/icon-ottoman-storage_1024x1024.png?v=90453762790681684271788964240';
  // assets['Studs'] = '//www.bedchoices.co.uk/cdn/shop/t/39/assets/icon-stud_1024x1024.png?v=86582165931147821201788964240';
  
  // let checkCount = 0;
  // const maxChecks = 20; // Stop after 20 checks
  // const interval = setInterval(function () {
  //     const element = $('#infiniteoptions-container');
  //     if (element.length) {
  //         console.log('#infiniteoptions-container exists!');
  //         setTimeout(function(){
  //             castleProductImprovement();
  //         },1500);
  //         clearInterval(interval); // Stop checking once the element is found
  //     } else {
  //         checkCount++;
  //         if (checkCount >= maxChecks) {
  //             console.log('Element not found after 20 checks.');
  //             clearInterval(interval); // Stop checking after maxChecks
  //         }
  //     }
  // }, 1000); 


  // if ($('.infiniteoptions-price').length){
  //   $('.infiniteoptions-price').appendTo('.product__add__cart__button button');
  // }

  
  // function castleProductImprovement(){

  
      
  //     $('.castle-options-selector').remove();

  //     var selectorHTML = '';
  //     selectorHTML+='<div class="castle-options-selector">';
    
  //     $('#infiniteoptions-container').children('div').each(function() {
          
  
  //         if ($(this).attr('disabled')  || $(this).hasClass('color_cover')){
  //             console.log('Skip this div');
  //         } else {
  //             var selectorName = $(this).find('.spb-label-tooltip > label').html();

                            
  //               console.log('spb-productdescfont', $(this).find('.spb-label-tooltip > label').html());
  
  //               var imageURL = 'https://dummyimage.com/50x50/000/fff';
  //               if (assets.hasOwnProperty(selectorName) && assets[selectorName]) {

  //                 $(this).addClass('castle-option').attr('data-castle-option',selectorName);
  //                 imageURL = assets[selectorName];
  //                 var selectorButtonHTML = '';
  //                 selectorButtonHTML+='<img title="' + selectorName + '" alt="' + selectorName + '" src="' + imageURL + '" class="img-fluid"/>';
  //                 selectorButtonHTML+='<label>' + selectorName + '</label>';
      
  //                 selectorHTML+='<div class="castle-target" data-target="' + selectorName + '" class="caste-option">' + selectorButtonHTML + '</div>';
  //               }else{

  //                 if (typeof(selectorName) != 'undefined'){
  //                   $(this).addClass('castle-option').attr('data-castle-option',selectorName);
  //                   var selectorButtonHTML = '';
  //                   selectorButtonHTML+='<img title="' + selectorName + '" alt="' + selectorName + '" src="' + imageURL + '" class="img-fluid"/>';
  //                   selectorButtonHTML+='<label>' + selectorName + '</label>';
  //                   selectorHTML+='<div class="castle-target" data-target="' + selectorName + '" class="caste-option">' + selectorButtonHTML + '</div>';
  //                 }
                  
                  
  //               }
    
                
  //         }
  
          
  //     });

  //     $('.spb-productoptionswatchwrapper').each(function() {
  //       var label = $(this).find('.spb-swatchlabel').html();
  //       var image = $(this).find('.spb-productoptionswatch').attr('data-image',label);
  //     });
  
  
  //     $(document).on('click','.castle-options-selector .castle-target',function(){
  //         $('.castle-option').removeClass('castle-active');
  //         var selector = $(this).attr('data-target');
  //         $('.castle-option[data-castle-option="' +selector+'"]').addClass('castle-active');
          
  //         $('.castle-options-selector > div').removeClass('active');
  //         $(this).addClass('active');

  //         $('.color_cover').css('opacity',0).hide();
  //         // $('select.spb-productdescfont').val('').trigger('change');
        
  //     });
  
  //     selectorHTML+='</div>';
  //     $('#infiniteoptions-container').before(selectorHTML);
  //     $('.castle-target').first().addClass('active').trigger('click');

  //     $('.castle-options-selector').addClass('castle-options-count-' + $('.castle-target').length);
  //   }



  // $('.add-to-basket-btn').on('click', function () {
  //   var $btn = $(this);
  //   var variantId = $btn.data('variant-id');

  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data: {
  //       quantity: 1,
  //       id: variantId
  //     },
  //     dataType: 'json',
  //     beforeSend: function () {
  //       $btn.prop('disabled', true);
  //       $btn.find('.action__btn--text--label').text('Adding...');
  //     },
  //     success: function () {
  //       $btn.find('.action__btn--text--label').text('Added!');
  //       document.dispatchEvent(new Event('open-mini-cart'));
  //       // Optional: trigger cart drawer or refresh cart icon
  //     },
  //     error: function () {
  //       $btn.find('.action__btn--text--label').text('Error');
  //     },
  //     complete: function () {
  //       setTimeout(function () {
  //         $btn.prop('disabled', false);
  //         $btn.find('.action__btn--text--label').text('ADD TO BASKET');

          
          
  //       }, 2000);

        
  //     }
  //   });
  // });


  $('.add-to-basket-btn').on('click', function () {
  const $btn = $(this);
  const variantId = $btn.data('variant-id');

  const submitButton = $btn.get(0); // raw DOM element
  submitButton.setAttribute('disabled', true);
  $btn.find('.action__btn--text--label').text('Adding...');
  submitButton.classList.add('loading');

  const cartNotification = document.querySelector('cart-notification');
  const cartItems = document.querySelector('cart-items');
  const quickViewWrapper = document.getElementById('quickViewWrapper');

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);

  if (cartNotification) {
    formData.append(
      'sections',
      cartNotification.getSectionsToRender().map((section) => section.id)
    );
    cartNotification.setActiveElement(document.activeElement);
  }

  if (cartItems) {
    formData.append(
      'sections',
      cartItems.getSectionsToRender().map((section) => section.section)
    );
  }

  formData.append('sections_url', window.location.pathname);

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((parsedState) => {
      if (parsedState.status) {
        console.error('Cart error:', parsedState.description);
        $btn.find('.action__btn--text--label').text('Error');
        return;
      }

      if (cartNotification) {
        cartNotification.renderContents(parsedState);
      }

      if (cartItems) {
        cartItems.renderContents(parsedState);
      }

      $btn.find('.action__btn--text--label').text('Added!');
    })
    .catch((e) => {
      console.error(e);
      $btn.find('.action__btn--text--label').text('Error');
    })
    .finally(() => {
      setTimeout(() => {
        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('loading');
        $btn.find('.action__btn--text--label').text('ADD TO CART');

        quickViewWrapper?.classList.remove('show__modal');
        document.body.classList.remove('overflow-hidden');

        $('.add_on_products_cover .related-product-list').hide();
      }, 2000);
    });
});



  $(document).on('click','.related-drawer-close',function(){
    closeMattressDrawer();
  });
    
  $('.add_on_products_cover .related-product-list').addClass('mattress-drawer');

  function openMattressDrawer() {
    $('body').addClass('mattress-picker').css('overflow', 'hidden');
    $('.add_on_products_cover .related-product-list').addClass('is-open');
  }

  function closeMattressDrawer() {
    $('body').removeClass('mattress-picker').css('overflow', '');
    $('.add_on_products_cover .related-product-list').removeClass('is-open');
  }

  $(document).on('click', '.btn-select-mattress', function(e) {
    e.stopPropagation();
    if ($('.add_on_products_cover .related-product-list').hasClass('is-open')) {
      closeMattressDrawer();
    } else {
      openMattressDrawer();


      var tab = $('.drawer-tab.active').data('tab');
      $('[data-firmness]').removeClass('active');
      $('[data-firmness="'+tab+'"]').addClass('active');


    }
  });
  $(document).on('click', '.related-product', function(e) {
    
    $('.related-product').removeClass('selected');
    $(this).addClass('selected');
    $('.mattress-save button').prop('disabled',false);

  });



  var OPEN = 'is-open';

  function cardData($btn) {
    var $card = $btn.closest('.related-product');
    var $img  = $card.find('.related-product-image img').first();
    var $name = $card.find('.related-product-name .title-container p');
    var save  = $.trim($card.find('.discount-price').text());
    return {
      src:   $img.length ? ($img.prop('currentSrc') || $img.prop('src')) : '',
      alt:   $img.attr('alt') || '',
      title: $.trim($name.eq(0).text()),
      size:  $.trim($name.eq(1).text()),
      sale:  $.trim($card.find('.related-product-price .sale-price').text()),
      was:   $.trim($card.find('.related-product-price .og-price').text()),
      save:  save ? save.replace(/^\s*Save/i, 'You save') : ''
    };
  }

  function buildHeader(d) {
    var $h = $('<div class="mmi-header"></div>');
    if (d.title) $h.append($('<h2 class="mmi-title"></h2>').text(d.title));
    if (d.size)  $h.append($('<p class="mmi-size"></p>').text(d.size));
    if (d.sale) {
      var $p = $('<p class="mmi-pricing"></p>')
        .append($('<span class="mmi-sale"></span>').text(d.sale));
      if (d.was) $p.append($('<span class="mmi-was"></span>').text(d.was));
      $h.append($p);
    }
    if (d.save) $h.append($('<p class="mmi-save"></p>').text(d.save));
    return $h;
  }

  function enhance($modal, d) {
    if ($modal.data('enhanced')) {
      if (d.src) $modal.find('.mmi-image img').attr('src', d.src).attr('alt', d.alt);
      return;
    }
    var $box   = $modal.find('.modal-content').addClass('mmi-box');
    var $close = $box.children('.close').addClass('mmi-close');

    var $body = $('<div class="mmi-body"></div>');
    $box.children().not($close).appendTo($body);   // existing <h2>/<p> features
    $body.prepend(buildHeader(d));                   // header on top

    var $col = $('<div class="mmi-image"></div>');
    if (d.src) $('<img loading="lazy">').attr({ src: d.src, alt: d.alt }).appendTo($col);

    $box.append($col).append($body);
    $modal.data('enhanced', true);
  }

  function open($modal, d) {
    enhance($modal, d);
    if (!$modal.parent().is('body')) $modal.appendTo('body'); // avoid carousel clipping
    $modal.addClass(OPEN);
    $('body').addClass('mmi-open');
  }
  function close($modal) {
    $modal.removeClass(OPEN);
    $('body').removeClass('mmi-open');
  }

  $(document)
    .on('click', '.mattress-more-info', function (e) {
      e.preventDefault();
      var $btn = $(this);
      var $modal = $('#mattress-more-info-content-' + $btn.data('variantId'));
      if ($modal.length) open($modal, cardData($btn));
    })
    .on('click', '.mattress-more-info-content .mmi-close', function () {
      close($(this).closest('.mattress-more-info-content'));
    })
    .on('click', '.mattress-more-info-content', function (e) {
      if (e.target === this) close($(this)); // backdrop only
    })
    .on('keydown', function (e) {
      if (e.key === 'Escape') close($('.mattress-more-info-content.' + OPEN));
    });
  
  $(document).on('click', '.drawer-tabs > div', function(e) {
    
      $(this).addClass('active').siblings().removeClass('active');
      var tab = $(this).data('tab');
      $('[data-firmness]').removeClass('active');
      $('[data-firmness="'+tab+'"]').addClass('active');

      $('.related-product').removeClass('selected');
      $('.mattress-save button').prop('disabled',true);

    
  });
  $(document).on('click', '#save-mattress', function(e) {
    
      $('.related-product.active.selected .add-to-basket-btn').trigger('click');
      closeMattressDrawer();

    
  });

  // Close on outside click
  $(document).on('click', function(e) {
    if (
      $('.add_on_products_cover .related-product-list').hasClass('is-open') &&
      !$(e.target).closest('.add_on_products_cover .related-product-list').length
    ) {
      closeMattressDrawer();
    }
  });

  // Close on ESC
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape') closeMattressDrawer();
  });


//  function moveCastleVariant() {
//     var $mediaGallery = $('.product__media_container ');
//     var $castleOptions = $('#castle-variant-options');
//     var $productTax = $('.product__tax');
  
//     if ($(window).width() <= 768) {
  
//       $mediaGallery.append($castleOptions);
//     } else {
//       $productTax.before($castleOptions);
//     }
//   }

// $(document).ready(function() {
//   moveCastleVariant(); // call on page load

//   $(window).resize(function() {
//     moveCastleVariant(); // call on window resize
//   });
// });


  

  
});